import { planContentPublish, readSchedule, scheduleFromTriggers } from "@platformx/utilities";

/**
 * What `CreateArticle.onPublish` has to decide before it touches the backend (KIWI-6576). The
 * decision itself lives in `planContentPublish`, shared by every content screen; this only reads the
 * Article's schedule — held in `CommonFields.settings` as form state, seeded on load with the
 * schedules the article already has (`seedSchedule`, KIWI-6762) — and its stored state.
 */
export const planArticlePublish = (articleInstance: any, now: Date = new Date()) => {
  const settings = articleInstance?.CommonFields?.settings;
  return planContentPublish(
    "Article",
    readSchedule(settings),
    articleInstance?.CommonFields?.page_state,
    now,
    scheduleFromTriggers(settings).initial,
  );
};
